const getters = {
  getTableOrder: state => state.tableOrder,
  getStateModal: state => state.modalAssignWaiter,
  getOrder: state => state.newOrder,
  getTables: state => state.tables
};

export default getters;
